<template>
  <div v-loading="loading" class="deviceShow">
    <el-row class="butcs">
      <el-button type="primary" @click="addrow">
        新增记录
      </el-button>
      <el-button type="success" @click="serve">
        保存记录
      </el-button>
    </el-row>
    <el-row class="listrow">
      <el-row v-for="(itme,index) in thermometerList" :key="index" class="rowtr">
        <el-col class="lableItme" :span="3">
          {{ index }}
        </el-col>
        <el-col :span="6">
          <el-col class="lablecs" :span="6">
            位置：
          </el-col>
          <el-col class="lableItme" :span="18">
            <el-select v-model="itme.Postion" class="selectel" placeholder="请选择">
              <el-option label="腋下" value="0" />
              <el-option label="胸前" value="1" />
            </el-select>
          </el-col>
        </el-col>
        <el-col :span="6">
          <el-col class="lablecs" :span="6">
            体表温度：
          </el-col>
          <el-col class="lableItme" :span="18">
            <el-input-number
              v-model="itme.Temperature_Sensor"
              class="numinput"
              :precision="2"
              :step="0.1"
              :max="40"
              :min="30"
            />
          </el-col>
        </el-col>
        <el-col :span="6">
          <el-col class="lablecs" :span="6">
            显示温度：
          </el-col>
          <el-col class="lableItme" :span="18">
            <el-input-number
              v-model="itme.Temperature_Show"
              class="numinput"
              :precision="2"
              :step="0.1"
              :max="40"
              :min="30"
            />
          </el-col>
        </el-col>
        <el-col class="lableItme" :span="3">
          <el-button type="danger" @click="delrow(index)">
            删除
          </el-button>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>
<script>
import request from '../utils/request.js'
export default {
  name: 'EditTemp',
  components: {},
  data() {
    return {
      loading: false,
      thermometerList: []
    }
  },
  mounted() {
    this.querys()
  },
  methods: {
    addrow() {
      if (this.thermometerList.length === 0) {
        this.thermometerList.push({
          Postion: '1',
          Temperature_Sensor: 34.0,
          Temperature_Show: 34.1
        })
      } else {
        this.thermometerList.push({
          Postion: '1',
          Temperature_Sensor:
            this.thermometerList[this.thermometerList.length - 1]
              .Temperature_Sensor + 0.1,
          Temperature_Show: this.thermometerList[
            this.thermometerList.length - 1
          ].Temperature_Show
        })
      }
    },
    delrow(index) {
      this.thermometerList.splice(index, 1)
    },
    querys() {
      request({
        url: '/thermometer/getRefPoints',
        method: 'post'
      }).then(Response => {
        console.log(Response)
        Response.data.data.forEach(element => {
          element.Postion = element.Postion + ''
          this.thermometerList.push(element)
        })
      })
    },
    serve() {
      this.loading = true
      request({
        url: '/thermometer/addrefpoint',
        method: 'post',
        data: this.thermometerList
      }).then(re => {
        console.log(re)
        if (re.data.data === 'OK') {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          this.loading = false
        }
      })
    }
  }
}
</script>

<style  scoped>
.lablecs {
  text-align: right;
  height: 50px;
  line-height: 50px;
}
.lableItme {
  /* text-align: right; */
  height: 50px;
  line-height: 50px;
}
.rowtr {
  margin: 2px;
  /* height: 30px; */
  /* line-height: 30px; */
}
.listrow{
  margin-top: 80px;
}
.listrow .rowtr:nth-child(even) {
  background: #ebeef5;
}
.butcs{
  margin-top: -60px;
  position:fixed;
  z-index: 88;
}
</style>
